<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row" v-if="!propOpenedInModal">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-users" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
            <div class="mt-2">{{userData.user_name}}</div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" @click="showManageRoles(`/organisation_edit/${orgType}/${orgId}#edit-roles`)">Manage Roles</b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col md="12" class="heading_alignment">
            <UserList v-if="orgType" :propModuleName="orgType"/>
          </b-col>
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import { socialvue } from "../../config/pluginInit"
import { Organisations } from "../../FackApi/api/organisation.js"
import userPermission from "../../Utils/user_permission"
import UserList from "../../views/User/UserInviteList.vue"

export default {
  name: "ManageUsers",
  components: {
    UserList
  },
  data () {
    return {
      apiName: "udfRole_list",
      cvCardTitle: "Team Member Dashboard",
      orgType: null,
      orgId: null,
      propOpenedInModal: false,
      orgData: {},
      isOrgAdmin: false,
      cvOrgId: null
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  async mounted () {
    socialvue.index()

    this.cvOrgId = this.$route.params.org_id
    if (!(this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11116" || this.userData.user_role == "USERROLE11118") && !this.cvOrgId) {
      // Unath Access for other roles or if org id is missing
      this.$router.push(`/home`)
    }

    let response = await this.getOrgDetails()
    if (!response) {
      // Org not found
      console.error(`Error: Manage Users: Org Data Not found for ${this.cvOrgId}`)
      this.$router.push(`/home`)
    }

    this.isOrgAdmin = this.userIsOrgAdmin()
    if (!(this.isOrgAdmin || (this.userData.roles[this.cvOrgId] && this.userData.roles[this.cvOrgId].udr_name))) {
      // User is Not an Admin or Have Edit/View Rights
      console.error(`Error: Manage Users: Unauth Access for ${this.cvOrgId}`)
      this.$router.push(`/home`)
    }

    if (!userPermission(this, this.userData, this.apiName)) {
      console.error(`Error: Manage Users: Unauth Access userPermission for ${this.cvOrgId} Not found`)
      this.$router.push(`/home`)
    }

    if (this.$route.params.org_type) {
      this.orgType = this.$route.params.org_type
    }

    if (this.$route.params.org_id) {
      this.orgId = this.cvOrgId
    }
  },
  methods: {
    /**
     * showManageRoles
     */
    showManageRoles (url) {
      this.$router.push(url)
    },
    /**
     * getOrgDetails
     */
    async getOrgDetails () {
      try {
        const orgDomain = window.location.hostname
        const orgDetails = await Organisations.organisationView(this, this.cvOrgId, orgDomain)
        if (!orgDetails.resp_status) {
          return false
        }
        this.orgData = orgDetails.resp_data.data

        // set the org data in local storage for saving in user table
        this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)

        return true
      }
      catch (err) {
        console.error("Exception in getOrgDetails and err: ", err)
        return false
      }
    },
    /**
     * userIsOrgAdmin
     */
    userIsOrgAdmin () {
      if (this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") {
        return true
      }

      if (this.userData.roles[this.cvOrgId] && this.userData.roles[this.cvOrgId].udr_name && (this.userData.roles[this.cvOrgId].udr_name.toLowerCase() === "admin" || this.userData.roles[this.cvOrgId].udr_name.toLowerCase() === "owner")) {
        return true
      }

      return false
    }
  }
}
</script>
<style lang="">
</style>
